// useFacebook.js - Custom Hook
import { useState, useEffect, useCallback } from 'react';
import FacebookService from '../services/Facebook/FacebookService';
// import FacebookService from './services/facebookService';

/**
 * Custom Hook để sử dụng Facebook SDK
 * @returns {Object} - Object chứa state và methods
 */
export const useFacebook = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [code, setCode] = useState(null);
  const [error, setError] = useState(null);

  // Khởi tạo Facebook SDK
  useEffect(() => {
    initFacebookSDK();
  }, []);

  const initFacebookSDK = async () => {
    try {
      await FacebookService.init();
      // const response = await FacebookService.getLoginStatus();
      // handleLoginStatus(response);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  // // Xử lý trạng thái đăng nhập
  // const handleLoginStatus = async (response) => {
  //   if (response.status === "connected") {
  //     setIsLoggedIn(true);
  //     await fetchUserData();
  //   } else {
  //     setIsLoggedIn(false);
  //     setUserData(null);
  //     setCode(null);
  //   }
  // };

  // // Lấy thông tin user
  // const fetchUserData = async () => {
  //   try {
  //     const data = await FacebookService.getUserInfo();
  //     const token = await FacebookService.getAccessToken();
  //     setUserData(data);
  //     setCode(token);
  //   } catch (err) {
  //     setError(err.message);
  //   }
  // };

  // Đăng nhập
  const login = useCallback(async () => {
    try {
      setError(null);
      FacebookService.loginWithCode();
      setCode(code);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    }
  }, []);

  // Đăng xuất
  const logout = useCallback(async () => {
    try {
      setError(null);
      await FacebookService.logout();
      setIsLoggedIn(false);
      setUserData(null);
      setCode(null);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    }
  }, []);

  // // Làm mới trạng thái
  // const refreshStatus = useCallback(async () => {
  //   try {
  //     setError(null);
  //     const response = await FacebookService.getLoginStatus();
  //     await handleLoginStatus(response);
  //   } catch (err) {
  //     setError(err.message);
  //   }
  // }, []);

  // // Gọi API
  // const callAPI = useCallback(async (path, params = {}) => {
  //   try {
  //     setError(null);
  //     return await FacebookService.api(path, params);
  //   } catch (err) {
  //     setError(err.message);
  //     throw err;
  //   }
  // }, []);

  return {
    // State
    isLoading,
    isLoggedIn,
    userData,
    code,
    error,

    // Methods
    login,
    logout,
    // refreshStatus,
    // callAPI,
  };
};

// Export default
export default useFacebook;

// ======================================
// CÁCH SỬ DỤNG TRONG COMPONENT:
// ======================================

/*
import useFacebook from './hooks/useFacebook';

function MyComponent() {
  const {
    isLoading,
    isLoggedIn,
    userData,
    accessToken,
    error,
    login,
    logout,
    refreshStatus
  } = useFacebook();

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      {!isLoggedIn ? (
        <button onClick={() => login()}>Đăng nhập</button>
      ) : (
        <div>
          <h2>Welcome, {userData.name}</h2>
          <button onClick={logout}>Đăng xuất</button>
        </div>
      )}
    </div>
  );
}
*/
